import { css } from '@/styled-system/css';

export const formStyles = css.raw({
  '& [data-c11n-component="FormActions"]': {
    marginBlockStart: 'Form.FormActions.marginTop',
  },
  '& [data-c11n-component="FormField"]:not(:last-child)': {
    marginBlockEnd: 'Form.FormField.marginBottom',
  },
  '& [data-c11n-component="FieldSet"]:not(:last-child)': {
    marginBlockEnd: 'Form.FieldSet.marginBottom',
  },
});
